import { Component, inject, Injector, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { LoadingService } from './services/local/loading.service';
import { CommonModule } from '@angular/common';
import { AlertService } from './services/local/alert.service';
import { AppConfigService } from './services/local/app-config.service';
import { filter } from 'rxjs';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet, CommonModule, LoadingOverlayComponent],
})
export class AppComponent{
  static injector: Injector;
  loadingSgnl: Signal<boolean>;
  private snackBar = inject(MatSnackBar);

  constructor(injector: Injector, loadingService: LoadingService, alertService: AlertService, appConfigService: AppConfigService) {
    AppComponent.injector = injector;
    this.loadingSgnl = loadingService.loadingSgnl;
    alertService.alert$.pipe(
      filter(mensaje => !!mensaje)
    )
    .subscribe(mensaje => {
      this.snackBar.open(mensaje, 'Cerrar', {
        duration: 3000
      });
    });
    appConfigService.init();
  }
}
